import { Component, namespace, Vue } from 'nuxt-property-decorator';
import { namespace as catalogStore, actionType } from '../store/modules/catalog-store';
import { IMenuTreeItem } from '../entities/menu-entity';

const CatalogStore = namespace(catalogStore);

interface IPageHead {
	title?: string;
}
@Component({
	async fetch(this: CategoriesListMixin): Promise<void> {
		await this.loadCatalog();
	},
})
export default class CategoriesListMixin extends Vue {
	@CatalogStore.Action(actionType.GET_CATALOG) getCatalog!: () => Promise<void>;
	@CatalogStore.Getter('catalogTree') catalogTree!: IMenuTreeItem[];

	get catalog(): IMenuTreeItem[] {
		if (this.catalogTree.length) {
			return this.catalogTree[0].items;
		}
		return [];
	}

	async loadCatalog(): Promise<void> {
		await this.getCatalog();
	}

	getPageHead(): IPageHead {
		return {};
	}
}
